var map = {
	"./card-random.svg": "7d77",
	"./cards/asclepius.svg": "23ec",
	"./cards/bread.svg": "8426",
	"./cards/chalice-purple.svg": "0f63",
	"./cards/chalice-red.svg": "0713",
	"./cards/chalice-yellow.svg": "c33d",
	"./cards/chicken.svg": "dcc5",
	"./cards/cow.svg": "aabc",
	"./cards/damage-purple.svg": "c2bd",
	"./cards/damage-red.svg": "1d84",
	"./cards/damage-yellow.svg": "8437",
	"./cards/default.svg": "f23d",
	"./cards/discard-hand.svg": "6eed",
	"./cards/dragon.svg": "7d5b",
	"./cards/draw-card.svg": "6bc4",
	"./cards/farmer.svg": "2f68",
	"./cards/forest-fire.svg": "207c",
	"./cards/forest.svg": "71c0",
	"./cards/freeze-blue.svg": "6e85",
	"./cards/freeze-purple.svg": "008b",
	"./cards/goblin.svg": "128e",
	"./cards/grain.svg": "6508",
	"./cards/hatchet-bronze.svg": "0bab",
	"./cards/hatchet-gold.svg": "2216",
	"./cards/hatchet-silver.svg": "de9a",
	"./cards/hatchet-stone.svg": "5390",
	"./cards/hourglass-purple.svg": "2651",
	"./cards/hourglass-red.svg": "7f2f",
	"./cards/hourglass-yellow.svg": "160d",
	"./cards/land-mine.svg": "65e1",
	"./cards/log.svg": "9cb0",
	"./cards/magic-touch.svg": "5a8a",
	"./cards/ore-bronze.svg": "56d2",
	"./cards/ore-gold.svg": "950c",
	"./cards/ore-silver.svg": "a1e3",
	"./cards/pickaxe-bronze.svg": "8e27",
	"./cards/pickaxe-gold.svg": "a164",
	"./cards/pickaxe-silver.svg": "59b6",
	"./cards/pickaxe-stone.svg": "59b5",
	"./cards/pig.svg": "2d1e",
	"./cards/rat.svg": "24a4",
	"./cards/sacrifice-hand.svg": "9cc9",
	"./cards/scythe-bronze.svg": "1be8",
	"./cards/scythe-gold.svg": "feae",
	"./cards/scythe-silver.svg": "370c",
	"./cards/scythe-stone.svg": "3dc5",
	"./cards/shield-cracked.svg": "ce81",
	"./cards/shield-viking.svg": "254a",
	"./cards/skeleton-king.svg": "6b48",
	"./cards/skeleton.svg": "cb5a",
	"./cards/spider-large.svg": "446f",
	"./cards/spider-small.svg": "fa78",
	"./cards/straw.svg": "7e84",
	"./cards/strike-purple.svg": "bcef",
	"./cards/strike-red.svg": "11b3",
	"./cards/strike-yellow.svg": "d167",
	"./cards/sword-bronze.svg": "4d2a",
	"./cards/sword-gold.svg": "0d68",
	"./cards/sword-silver.svg": "9879",
	"./cards/sword.svg": "e7a0",
	"./cards/tree.svg": "6f7d",
	"./cards/troll.svg": "8f9a",
	"./coins.svg": "fe61",
	"./logo.png": "cf05",
	"./orbs/bronze.svg": "050f",
	"./orbs/clock.svg": "e947",
	"./orbs/gold.svg": "70c0",
	"./orbs/grain.svg": "1ed1",
	"./orbs/heart.svg": "d5ac",
	"./orbs/ice.svg": "45e6",
	"./orbs/silver.svg": "ad29",
	"./orbs/souls.svg": "d0d2",
	"./orbs/sword.svg": "9021",
	"./orbs/wood.svg": "5123"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";